import React from "react";
import Form from "react-bootstrap/Form";

const CustomForm = ({
  controlText,
  color,
  lableText,
  placeholderText,
  type,
  value,
  onChange,
  name,
  className,
}) => {
  return (
    <Form.Group className={className} controlId={controlText}>
      <Form.Label style={{ color: color }}>{lableText}</Form.Label>
      <Form.Control
        onChange={onChange}
        value={value}
        type={type}
        placeholder={placeholderText}
        name={name}
      />
    </Form.Group>
  );
};
export default CustomForm;
